import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ConfiguracaoPedidoRequest } from '../../requests/compras/configuracao-pedido.request';
import { GetConfiguracaoPedidoResponse } from '../../responses/compras/configuracao-pedido.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class ConfiguracaoPedidoService extends CommonService {
  private readonly apiUrl: string = environment.urlApiCompras + 'ConfiguracaoPedido';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public get(): Observable<GetConfiguracaoPedidoResponse> {
    return this.httpClient
      .get<GetConfiguracaoPedidoResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public salvar(request: ConfiguracaoPedidoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

}
